var map = {
	"./amex.svg": 79462,
	"./cartes_bancaires.svg": 4602,
	"./diners_club.svg": 63647,
	"./discover.svg": 18118,
	"./jcb.svg": 79260,
	"./mastercard.svg": 94459,
	"./unionpay.svg": 55170,
	"./visa.svg": 23532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36573;